import { createSlice } from "@reduxjs/toolkit";
import { SocialAccountState } from "types/social-account";
import { fetchSocialAccountThunk } from "./thunk";

const initialState: SocialAccountState = {
    loading: false,
    error: null,
    list: {
        loading: false,
        last_fetched_at: 0,
        items: [],
        error: null
    },
    items: {}
}

const socialAccountState = createSlice({
    name: 'socialAccountState',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchSocialAccountThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchSocialAccountThunk.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.error = null;
            const {socialAccountId, socialAccount, cached} = payload;
            state.items[socialAccountId] = {
                last_fetched_at: cached ? (state.items[socialAccountId]?.last_fetched_at ?? 0) : Date.now(),
                account: socialAccount
            }
        })
        .addCase(fetchSocialAccountThunk.rejected, (state) => {
            state.loading = false;
            state.error = "Failed to fetch social account"
        })
    }
})

export default socialAccountState.reducer;